import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../../primitives/ids.js";
export const CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID = "website-delivery.v1";
export const DeliveryProjectIdSchema = z.string().regex(/^wdproj_[a-zA-Z0-9_-]+$/);
export const WorkItemIdSchema = z.string().regex(/^wdwi_[a-zA-Z0-9_-]+$/);
export const MilestoneIdSchema = z.string().regex(/^wdms_[a-zA-Z0-9_-]+$/);
export const AssignmentIdSchema = z.string().regex(/^wdas_[a-zA-Z0-9_-]+$/);
export const ClientContactIdSchema = z.string().regex(/^wdcc_[a-zA-Z0-9_-]+$/);
export const DeliveryStatusEventIdSchema = z.string().regex(/^wdse_[a-zA-Z0-9_-]+$/);
export const OperationalNoteIdSchema = z.string().regex(/^wdon_[a-zA-Z0-9_-]+$/);
export const DeliveryProjectV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.delivery-project.v1.0"),
    deliveryProjectId: DeliveryProjectIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    verticalId: z.literal(CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID),
    title: z.string().min(1),
    internalStatus: z.enum(["DRAFT", "ACTIVE", "ON_HOLD", "COMPLETE"]),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const WorkItemV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.work-item.v1.0"),
    workItemId: WorkItemIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    agencyId: AgencyIdSchema,
    title: z.string().min(1),
    internalPriority: z.enum(["LOW", "NORMAL", "HIGH"]),
    createdAt: z.string().datetime(),
})
    .strict();
export const MilestoneV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.milestone.v1.0"),
    milestoneId: MilestoneIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    agencyId: AgencyIdSchema,
    label: z.string().min(1),
    internalDueAt: z.string().datetime().optional(),
    publicLabel: z.string().min(1).optional(),
    createdAt: z.string().datetime(),
})
    .strict();
export const AssignmentV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.assignment.v1.0"),
    assignmentId: AssignmentIdSchema,
    workItemId: WorkItemIdSchema,
    agencyId: AgencyIdSchema,
    assigneeLabel: z.string().min(1),
    createdAt: z.string().datetime(),
})
    .strict();
export const ClientContactV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.client-contact.v1.0"),
    clientContactId: ClientContactIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    agencyId: AgencyIdSchema,
    displayName: z.string().min(1),
    email: z.string().email().optional(),
    phone: z.string().min(3).optional(),
    createdAt: z.string().datetime(),
})
    .strict();
export const DeliveryStatusEventV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.delivery-status-event.v1.0"),
    eventId: DeliveryStatusEventIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    agencyId: AgencyIdSchema,
    status: z.enum(["NOTE", "BLOCKED", "UNBLOCKED", "MILESTONE_REACHED"]),
    message: z.string().min(1),
    recordedAt: z.string().datetime(),
})
    .strict();
export const OperationalNoteV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.operational-note.v1.0"),
    noteId: OperationalNoteIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    agencyId: AgencyIdSchema,
    body: z.string().min(1),
    visibility: z.literal("INTERNAL_ONLY"),
    createdAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=entities.js.map